import type { Link } from "@circle-react-shared/SettingsNav/NestedNavBar/types";

import type { BuildNavSubItem } from "./types";
import type { SettingsNavLinks } from "./useSettingsNavLinks";

const toSubItems = (links: Link[]): BuildNavSubItem[] =>
  links
    .filter(link => !link.isDisabled)
    .map(link => ({
      id: link.path,
      label: link.label,
      to: link.path,
      exact: link.exact,
    }));

/**
 * Maps each top-level settings section (by `pathKey` from
 * `useCollapsedSidebarLinksV3`) to its sub-navigation items, reusing the exact
 * same link definitions that power the settings `NestedNavBar`. This keeps the
 * Circle AI dock's collapsible Build groups in sync with the real settings nav
 * (permissions, feature flags, and disabled-link handling included). Pure so it
 * can share resolved links from `useSettingsNavLinks` with the Settings groups.
 */
export const buildSettingsNavSubItems = (
  links: SettingsNavLinks,
): Record<string, BuildNavSubItem[]> => ({
  members: toSubItems(links.members),
  content: toSubItems(links.content),
  email: toSubItems(links.email),
  newsletter: toSubItems(links.newsletter),
  courses: toSubItems(links.courses),
  workflows: toSubItems(links.workflows),
  analytics_v2: toSubItems(links.analytics_v2),
  community_bot: toSubItems(links.community_bot),
  paywalls: toSubItems(links.paywalls),
  affiliates: toSubItems(links.affiliates),
  plans: toSubItems(links.plans),
  plus: toSubItems(links.plus),
  site: toSubItems(links.site),
  developers: toSubItems(links.developers),
  settings: toSubItems(links.settings),
});
